export enum EnvironmentPresetKind {
	NONE = "NONE",
	ECMA = "ECMA",
	BROWSER = "BROWSER",
	NODE = "NODE"
}
